import Component from '../colorz/Component';
import Splide from '@splidejs/splide';
import {sliderOptions} from '../colorz/configClrzApp';

export default class LastReviewsBz extends Component {
	onInit(el) {
		this.el = el;
		this.slider = this.el;
		this.sliderList = this.slider.querySelector('.splide__list');
		this.numberReviews = Number(this.el.dataset.numberReviews);
		this.elTextBy = this.dataset?.StringReviewsBy || 'Reviews by';
		this.filterRated = this.el.dataset.filterRated;
		this.hideTaggedArray = this.el.dataset.hideTagged.split(',');
		this.keyBazaarvoice = this.el.dataset.keyBazaarvoice;
	}

	async onReady() {
		if (!this.keyBazaarvoice) return;
		this.data = await this.fetchProductReviews();
		if (this.data) {
			await this.renderReviews();
		}
	}

	async renderReviews() {
		const promises = this.data.Results.map((el) => this.createElement(el));

		try {
			await Promise.all(promises);
			this.initSlider();
			this.el.removeAttribute('hidden');
		} catch (e) {
			console.error('Error rendering reviews', e);
		}
	}

	createElement(el) {
		return new Promise((resolve) => {
			const process = async () => {
				if (el.ReviewText) {
					const slideElement = document.createElement('div');
					slideElement.classList.add('splide__slide');

					const reviewElement = document.createElement('div');
					reviewElement.classList.add(
						'u-bg-white',
						'md:u-bg-blue-light',
						'u-py-20',
						'u-px-25',
						'md:u-p-0',
					);

					let reviewProductURL = '',
						reviewProductURLClass = 'u-pointer-events-none';
					const productInfo = await this.getProductInfo(el.ProductId);

					// Check if the product has tags and if any of the tags are in the hideTaggedArray
					const productTags = productInfo?.tags || [];
					if (this.hideTaggedArray.some((tag) => productTags.includes(tag))) {
						return resolve();
					}

					if (productInfo) {
						const productURL = new URL(
							window.location.origin + productInfo.url,
						);
						productURL.search = '';

						reviewProductURL = productURL;
						reviewProductURLClass = '';
					}

					const reviewStars = this.drawRatingStars(el.Rating).outerHTML;

					reviewElement.innerHTML = `
						<a href="${reviewProductURL}" class="u-relative u-flex u-flex-col t-text t-text--14 u-text-blue ${reviewProductURLClass}">
								<p class="u-relative">
										<p class="u-underline u-underline-offset-4 u-decoration-2">${el.OriginalProductName}</p>
								</p>
								<div class="u-flex u-items-center u-gap-x-10 u-mt-10">
									${reviewStars} (${el.Rating})
								</div>
								<p class="u-mt-10 u-break-words u-line-clamp-6 md:u-line-clamp-4">${el.ReviewText}</p>
						</a>
				`;

					slideElement.appendChild(reviewElement);

					this.sliderList.appendChild(slideElement);

					resolve();
				} else {
					resolve();
				}
			};
			process();
		});
	}

	drawRatingStars(rating) {
		const pourcentage = 100 - (rating / 5) * 100;
		const elStarts = document.createElement('div');
		elStarts.classList.add('u-grid', 'u-w-fit');
		elStarts.innerHTML = `		
			<div class='u-flex u-gap-x-[8px] u-col-start-1 u-row-start-1'>
				<svg
					width='13.5'
					height='13.5'
					viewBox='0 0 22 22'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path d="M11.2327 17.1824L11 17.0601L10.7673 17.1824L5.05148 20.1874L6.14311 13.8227L6.18755 13.5637L5.99931 13.3802L1.3751 8.87268L7.76561 7.94408L8.02574 7.90628L8.14208 7.67056L11 1.87978L13.8579 7.67056L13.9743 7.90628L14.2344 7.94408L20.6249 8.87268L16.0007 13.3802L15.8125 13.5637L15.8569 13.8227L16.9485 20.1874L11.2327 17.1824Z" stroke="#F7B604"/>
				</svg>
				<svg
					width='13.5'
					height='13.5'
					viewBox='0 0 22 22'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path d="M11.2327 17.1824L11 17.0601L10.7673 17.1824L5.05148 20.1874L6.14311 13.8227L6.18755 13.5637L5.99931 13.3802L1.3751 8.87268L7.76561 7.94408L8.02574 7.90628L8.14208 7.67056L11 1.87978L13.8579 7.67056L13.9743 7.90628L14.2344 7.94408L20.6249 8.87268L16.0007 13.3802L15.8125 13.5637L15.8569 13.8227L16.9485 20.1874L11.2327 17.1824Z" stroke="#F7B604"/>
				</svg>
				<svg
					width='13.5'
					height='13.5'
					viewBox='0 0 22 22'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path d="M11.2327 17.1824L11 17.0601L10.7673 17.1824L5.05148 20.1874L6.14311 13.8227L6.18755 13.5637L5.99931 13.3802L1.3751 8.87268L7.76561 7.94408L8.02574 7.90628L8.14208 7.67056L11 1.87978L13.8579 7.67056L13.9743 7.90628L14.2344 7.94408L20.6249 8.87268L16.0007 13.3802L15.8125 13.5637L15.8569 13.8227L16.9485 20.1874L11.2327 17.1824Z" stroke="#F7B604"/>
				</svg>
				<svg
					width='13.5'
					height='13.5'
					viewBox='0 0 22 22'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path d="M11.2327 17.1824L11 17.0601L10.7673 17.1824L5.05148 20.1874L6.14311 13.8227L6.18755 13.5637L5.99931 13.3802L1.3751 8.87268L7.76561 7.94408L8.02574 7.90628L8.14208 7.67056L11 1.87978L13.8579 7.67056L13.9743 7.90628L14.2344 7.94408L20.6249 8.87268L16.0007 13.3802L15.8125 13.5637L15.8569 13.8227L16.9485 20.1874L11.2327 17.1824Z" stroke="#F7B604"/>
				</svg>
				<svg
					width='13.5'
					height='13.5'
					viewBox='0 0 22 22'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path d="M11.2327 17.1824L11 17.0601L10.7673 17.1824L5.05148 20.1874L6.14311 13.8227L6.18755 13.5637L5.99931 13.3802L1.3751 8.87268L7.76561 7.94408L8.02574 7.90628L8.14208 7.67056L11 1.87978L13.8579 7.67056L13.9743 7.90628L14.2344 7.94408L20.6249 8.87268L16.0007 13.3802L15.8125 13.5637L15.8569 13.8227L16.9485 20.1874L11.2327 17.1824Z" stroke="#F7B604"/>
				</svg>
			</div>
			<div
				class='u-flex u-gap-x-[8px] u-col-start-1 u-row-start-1 '
				style='clip-path: inset(0 ${pourcentage}% 0 0)'
			>
				<svg
					width='13.5'
					height='13.5'
					viewBox='0 0 22 22'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M11 17.625L4.38742 21.1014L5.65031 13.7382L0.300614 8.52356L7.69371 7.44928L11 0.75L14.3063 7.44928L21.6994 8.52356L16.3497 13.7382L17.6126 21.1014L11 17.625Z" fill="#F7B604"/>
				</svg>
				<svg
					width='13.5'
					height='13.5'
					viewBox='0 0 22 22'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M11 17.625L4.38742 21.1014L5.65031 13.7382L0.300614 8.52356L7.69371 7.44928L11 0.75L14.3063 7.44928L21.6994 8.52356L16.3497 13.7382L17.6126 21.1014L11 17.625Z" fill="#F7B604"/>
				</svg>
				<svg
					width='13.5'
					height='13.5'
					viewBox='0 0 22 22'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M11 17.625L4.38742 21.1014L5.65031 13.7382L0.300614 8.52356L7.69371 7.44928L11 0.75L14.3063 7.44928L21.6994 8.52356L16.3497 13.7382L17.6126 21.1014L11 17.625Z" fill="#F7B604"/>
				</svg>
				<svg
					width='13.5'
					height='13.5'
					viewBox='0 0 22 22'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M11 17.625L4.38742 21.1014L5.65031 13.7382L0.300614 8.52356L7.69371 7.44928L11 0.75L14.3063 7.44928L21.6994 8.52356L16.3497 13.7382L17.6126 21.1014L11 17.625Z" fill="#F7B604"/>
				</svg>
				<svg
					width='13.5'
					height='13.5'
					viewBox='0 0 22 22'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M11 17.625L4.38742 21.1014L5.65031 13.7382L0.300614 8.52356L7.69371 7.44928L11 0.75L14.3063 7.44928L21.6994 8.52356L16.3497 13.7382L17.6126 21.1014L11 17.625Z" fill="#F7B604"/>
				</svg>
			</div>
		`;

		return elStarts;
	}

	async fetchProductReviews() {
		const URL_BZ = new URL('https://api.bazaarvoice.com/data/reviews.json');
		URL_BZ.searchParams.append('apiversion', '5.4');
		URL_BZ.searchParams.append('passkey', this.keyBazaarvoice);
		URL_BZ.searchParams.append('Limit', this.numberReviews);
		this.filterRated &&
			URL_BZ.searchParams.append('Filter', `Rating:eq:${this.filterRated}`);
		try {
			const response = await fetch(URL_BZ);
			if (!response.ok) {
				throw new Error('Network response was not ok');
			}
			return await response.json();
		} catch (error) {
			console.error('Error fetching product reviews', error);
			return null;
		}
	}

	initSlider() {
		this.options = !!this.slider.dataset.options
			? sliderOptions[this.slider.dataset.options]
			: {};
		this.options = {...this.defaultOptions, ...this.options};

		this.splide = new Splide(this.slider, this.options);

		setTimeout(() => {
			this.splide.mount();
		}, 10);
	}

	async getProductInfo(id) {
		const URL_Search = new URL(window.location.href);
		URL_Search.pathname = 'search/suggest.json';
		URL_Search.searchParams.append('q', `id:${Number(id)}`);
		URL_Search.searchParams.append('resources[type]', 'product');
		URL_Search.searchParams.append('limit', 1);

		try {
			const response = await fetch(URL_Search);
			if (!response.ok) {
				throw new Error('Network response was not ok');
			}
			const data = await response.json();
			return data.resources.results.products[0];
		} catch (error) {
			console.error('Error fetching product info', error);
			return null;
		}
	}
}
